import { render, staticRenderFns } from "./AppText.vue?vue&type=template&id=6b64efb7&scoped=true&functional=true&"
import script from "./AppText.vue?vue&type=script&lang=js&"
export * from "./AppText.vue?vue&type=script&lang=js&"
import style0 from "./AppText.vue?vue&type=style&index=0&id=6b64efb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6b64efb7",
  null
  
)

export default component.exports